export default "__VITE_ASSET__672a6f2e__"